import { useTranslation } from 'react-i18next'
import {
  AuftragOption,
  AuftragOptionen,
  BefehlFormAuftrag,
  BefehlFormField
} from '../Generic'
import {
  ControllerRenderProps,
  FieldErrors,
  useFormContext
} from 'react-hook-form'
import { BetriebsstelleField } from '../../form'
import { Betriebsstellenart } from '../../../types'
import { useMemo } from 'react'

export interface Auftrag22_10FormProps {
  fieldPrefix: string
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings?: boolean
  errors?: FieldErrors
}

export default function Auftrag22_10Form({
  readOnly,
  fieldPrefix,
  'data-testid': testId,
  errors,
  activateEmptyFieldWarnings = false
}: Readonly<Auftrag22_10FormProps>) {
  const formContext = useFormContext()
  const { control, formState, watch } = formContext

  const fieldErrors = useMemo(() => {
    return errors ?? formState.errors
  }, [errors, formState.errors])

  const { t } = useTranslation('ui-befehle')

  const selector = watch(`${fieldPrefix}.selector`)

  return (
    <BefehlFormAuftrag
      auftragKennung="22.10"
      fieldName={`${fieldPrefix}.enabled`}
      readOnly={true}
      disabled={false}
      testId={testId}
    >
      <div className="flex flex-col flex-wrap items-baseline sm:flex-row w-full gap-0.5">
        <span data-testid={`${testId}-text`}>{t('auftraege.22_10.label')}</span>
        <BefehlFormField
          name={`${fieldPrefix}.selector`}
          control={control}
          label=""
          readOnly={readOnly}
          activateEmptyWarning={activateEmptyFieldWarnings}
          useTextDisplayInReadOnly={false}
          data-testid={`${testId}-feld-22-11-12-selector`}
          render={({ field }: { field: ControllerRenderProps }) => (
            <AuftragOptionen
              name={`${fieldPrefix}.selector`}
              value={field.value}
              onChange={field.onChange}
              readOnly={readOnly}
              errors={fieldErrors}
              data-testid={`${testId}-feld-22-11-12-selector-options`}
            >
              <AuftragOption
                value={Betriebsstellenart.Bf}
                label={t('auftraege.22_10.bf_label')}
                data-testid={`${testId}-feld-22-11-12-selector-options-bf`}
              >
                <BefehlFormField
                  name={`${fieldPrefix}.name`}
                  label={t('auftraege.22_10.bf')}
                  control={control}
                  readOnly={readOnly}
                  activateEmptyWarning={activateEmptyFieldWarnings}
                  data-testid={`${testId}-feld-22-11`}
                  render={({ field: zmField }) => (
                    <BetriebsstelleField
                      {...zmField}
                      label={t('auftraege.22_10.bf')}
                      variant="solid"
                      className="w-full"
                      data-testid={`${testId}-feld-22-11-inner`}
                      errors={fieldErrors}
                      typ={selector}
                    />
                  )}
                />
              </AuftragOption>
              <AuftragOption
                value={Betriebsstellenart.Bft}
                label={t('auftraege.22_10.bft_label')}
                data-testid={`${testId}-feld-22-11-12-selector-options-bft`}
              >
                <BefehlFormField
                  name={`${fieldPrefix}.name`}
                  label={t('auftraege.22_10.bft')}
                  control={control}
                  readOnly={readOnly}
                  activateEmptyWarning={activateEmptyFieldWarnings}
                  data-testid={`${testId}-feld-22-12`}
                  render={({ field: zmField }) => (
                    <BetriebsstelleField
                      {...zmField}
                      label={t('auftraege.22_10.bft')}
                      variant="solid"
                      className="w-full"
                      data-testid={`${testId}-feld-22-12-inner`}
                      errors={fieldErrors}
                      typ={selector}
                    />
                  )}
                />
              </AuftragOption>
            </AuftragOptionen>
          )}
        />
        <span data-testid={`${testId}-text-ausfahren`}>
          {t('auftraege.22_10.ausfahren')}
        </span>
      </div>
    </BefehlFormAuftrag>
  )
}
